// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"b98f73d0","611":"bf9e94fe","652":"bfdc2320","665":"572b981e","787":"74498ed1"}[chunkId] + ".chunk.js";
};